const state = {
  formsError: false,
  materialsError: false,
  randError: false,
  shippingError: false,
  basicsError: false,
  islandsError: false,
  orderError: false,
  visitorError: false,
  couponError: false,
  vatError: false,
  contactError: false
}

const mutations = {
  'FORMS_LOADING_ERROR' (state) {
    state.formsError = true
  },
  'MATERIALS_LOADING_ERROR' (state) {
    state.materialsError = true
  },
  'RAND_LOADING_ERROR' (state) {
    state.randError = true
  },
  'SHIPPING_LOADING_ERROR' (state) {
    state.shippingError = true
  },
  'BASICS_LOADING_ERROR' (state) {
    state.basicsError = true
  },
  'ISLANDS_LOADING_ERROR' (state) {
    state.islandsError = true
  },
  'ORDER_LOADING_ERROR' (state) {
    state.orderError = true
  },
  'VISITOR_LOADING_ERROR' (state) {
    state.visitorError = true
  },
  'COUPON_LOADING_ERROR' (state) {
    state.couponError = true
  },
  'VAT_LOADING_ERROR' (state) {
    state.vatError = true
  },
  'CONTACT_LOADING_ERROR' (state) {
    state.contactError = true
  }
}

const actions = {
  formsLoadingError: ({ commit }) => {
    commit('FORMS_LOADING_ERROR')
  },
  materialsLoadingError: ({ commit }) => {
    commit('MATERIALS_LOADING_ERROR')
  },
  randLoadingError: ({ commit }) => {
    commit('RAND_LOADING_ERROR')
  },
  shippingLoadingError: ({ commit }) => {
    commit('SHIPPING_LOADING_ERROR')
  },
  basicsLoadingError: ({ commit }) => {
    commit('BASICS_LOADING_ERROR')
  },
  islandsLoadingError: ({ commit }) => {
    commit('ISLANDS_LOADING_ERROR')
  },
  orderLoadingError: ({ commit }) => {
    commit('ORDER_LOADING_ERROR')
  },
  visitorLoadingError: ({ commit }) => {
    commit('VISITOR_LOADING_ERROR')
  },
  couponLoadingError: ({ commit }) => {
    commit('COUPON_LOADING_ERROR')
  },
  vatLoadingError: ({ commit }) => {
    commit('VAT_LOADING_ERROR')
  },
  contactLoadingError: ({ commit }) => {
    commit('CONTACT_LOADING_ERROR')
  }
}

const getters = {
  loadingError: state => {
    return (state.formsError || state.materialsError || state.randError || state.shippingError || state.basicsError || state.islandsError || state.orderError || state.visitorError || state.couponError || state.vatError || state.contactError)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
